import PriceSchemeBandsRulesTab from './PriceSchemeBandsRulesTab';
export default PriceSchemeBandsRulesTab;
